module.exports = __webpack_public_path__ + "static/media/cq_ordine_tempo1 b.0936011c.svg";